module.exports = __webpack_public_path__ + "97fbc865150af973590a557b0086ef14.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/01GoldenCityHafenbar.jpg
// module id = 878
// module chunks = 0